import Schema from 'AppReact/schema';
import { makeReadyCard } from 'types';

export default {
  isSelected: Schema('boolean', 'primitive', { defaultValue: false }),
  property: Schema('string', 'primitive', { defaultValue: '' }),
  unit: Schema('string', 'primitive', { defaultValue: '' }),
  card: Schema(makeReadyCard, 'object', { defaultValue: Schema(makeReadyCard).sampleData() }),
  showSelectCheckbox: Schema('boolean', 'primitive-nullable', { defaultValue: null }),
  exceptions: Schema('string', 'array', { defaultValue: [] })
};
